import React from 'react'
import error from '../error.png'
import PropTypes from 'prop-types'
import InfoBox from './InputRowHoverOrClickInfo'
import { getDevice } from './CheckDevice'
export default class InputRow extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      mouseOver: false
    }
  }

  render () {
    const userDevice = getDevice()
    let classNameofMainDiv = 'input-control'
    if (this.props.name === 'select') {
      classNameofMainDiv = 'input-control select-box'
    }
    return (
      <div className="wrapper">
        <div className="input-wrapper-main">
          <div className={classNameofMainDiv} style={this.props.errMsg ? { borderWidth: 1, borderColor: 'red' } : null}>
            <span className="label">{this.props.rowName}<label style={{ color: 'red' }}>{this.props.required}</label></span>
            {this.props.name === 'select'
              ? <select
                onChange={(e) => {
                  if (sessionStorage.getItem('isBlocking') === 'false') { sessionStorage.setItem('isBlocking', true) }
                  this.props.onChange(e.target.value)
                }
                }
                value={this.props.value}
                disabled={this.props.disabled}>
                {this.props.data.length ? <option value={''} key={0 + '' + this.props.rowName}>Select</option> : null}
                {this.props.data.length ? this.props.data.map(element => {
                  return <option value={element.Id} key={element.Id + ' ' + element.value}>{element.value}</option>
                }) : <option value={0} key={'Select'}>Select</option>}

              </select>
              : ['date', 'percent'].indexOf(this.props.name) !== -1
                ? <input
                  type={this.props.name}
                  id={this.props.name + '_' + this.props.rowName}
                  value={this.props.value}
                  direction= {this.props.direction}
                  disabled={this.props.disabled}
                  onChange={(e) => {
                    if (sessionStorage.getItem('isBlocking') === 'false') { sessionStorage.setItem('isBlocking', true) }
                    this.props.onChange(e.target.value)
                  }
                  }
                  onKeyDown={e => e.preventDefault(alert('Please use the calendar control icon to modify the dates'))}
                  onKeyPress={(e) => this.props.onKeyPress ? this.props.onKeyPress(e) : null}
                  min={this.props.name === 'date' ? '1900-01-01' : null}
                  max={this.props.name === 'date' ? '2050-12-31' : null}
                />

                : ['number', 'percent'].indexOf(this.props.name) !== -1
                  ? <input
                    type='number'
                    step={this.props.name === 'percent' ? 0.01 : 1}
                    min={0}
                    max={this.props.name === 'percent' ? 100 : null}
                    id={this.props.name + '_' + this.props.rowName}
                    value={this.props.value}
                    disabled={this.props.disabled}
                    onChange={(e) => {
                      if (sessionStorage.getItem('isBlocking') === 'false') { sessionStorage.setItem('isBlocking', true) }
                      this.props.onChange(e.target.value)
                    }
                    }
                    onKeyPress={(e) => this.props.onKeyPress ? this.props.onKeyPress(e) : null}
                  />
                  : <input
                    type={this.props.name}
                    id={this.props.name + '_' + this.props.rowName}
                    value={this.props.value}
                    direction= {this.props.direction}
                    disabled={this.props.disabled}
                    onChange={(e) => {
                      if (sessionStorage.getItem('isBlocking') === 'false') { sessionStorage.setItem('isBlocking', true) }
                      this.props.onChange(e.target.value)
                    }
                    }
                    onKeyPress={(e) => this.props.onKeyPress ? this.props.onKeyPress(e) : null}
                    min={this.props.name === 'date' ? '1900-01-01' : null}
                    max={this.props.name === 'date' ? '2050-12-31' : null}
                  />
            }

            {this.props.error
              ? <div>
                <div style={{ flexDirection: 'row', display: 'flex' }}>
                  <img src={error} alt={this.props.rowName + ' is not valid'} style={{ width: 15, height: 15 }} />
                  <p>{this.props.rowName} is not valid.</p>
                </div>
              </div>
              : null}
          </div>
          {
            this.props.hover ? (
              userDevice === 'Desktop' ? <label
                onMouseOver={() => this.setState({ mouseOver: true })}
                onMouseOut={() => this.setState({ mouseOver: false })}
                className="help"
              >
              ?
              </label> : <label
                onClick={() => this.setState({ mouseOver: true })}
                className="help"
              >
              ?
              </label>
            ) : null
          }
          <div className={this.state.mouseOver ? 'hint' : ' hint hidden'}>
            <InfoBox show={this.state.mouseOver} onClickOutside={() => this.setState({ mouseOver: false })} message={this.props.hover}/>
          </div>
        </div>
        <div style={{ display: this.props.errMsg ? 'block' : 'none', width: '100%', marginLeft: 5, paddingBottom: 5 }}><span style={{ color: 'red', fontSize: 12 }}>{this.props.errMsg}</span></div>
      </div>
    )
  }
}
InputRow.propTypes = {
  name: PropTypes.any.isRequired,
  rowName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  required: PropTypes.string,
  hover: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  data: PropTypes.array,
  onKeyPress: PropTypes.func,
  errMsg: PropTypes.string
}
